export const learnerProgress = {
  '1': { // Thabo Mthembu
    enrolledModules: ['1', '2'],
    completedModules: [],
    currentModule: '1',
    moduleProgress: {
      '1': {
        enrolledAt: '2025-07-14',
        startedAt: '2025-07-14',
        completedAt: null,
        progress: 80, // percentage
        completedLessons: ['1-1', '1-2', '1-3', '1-4'],
        currentLesson: '1-5',
        totalTimeSpent: 680, // minutes
        achievements: ['first_lesson', 'digital_literacy_expert', 'communication_pro'],
        lastAccessDate: '2025-07-17'
      },
      '2': {
        enrolledAt: '2025-07-21',
        startedAt: null,
        completedAt: null,
        progress: 0,
        completedLessons: [],
        currentLesson: null,
        totalTimeSpent: 0,
        achievements: [],
        lastAccessDate: null
      }
    }
  },
  '2': { // Nomsa Dlamini
    enrolledModules: ['1', '2', '3'],
    completedModules: ['1'],
    currentModule: '2',
    moduleProgress: {
      '1': {
        enrolledAt: '2025-07-14',
        startedAt: '2025-07-14',
        completedAt: '2025-07-18',
        progress: 100,
        completedLessons: ['1-1', '1-2', '1-3', '1-4', '1-5'],
        currentLesson: null,
        totalTimeSpent: 1050,
        achievements: ['first_lesson', 'digital_literacy_expert', 'communication_pro', 'module_complete', 'speed_learner'],
        lastAccessDate: '2025-07-18'
      },
      '2': {
        enrolledAt: '2025-07-21',
        startedAt: '2025-07-21',
        completedAt: null,
        progress: 60,
        completedLessons: ['2-1', '2-2', '2-3'],
        currentLesson: '2-4',
        totalTimeSpent: 580,
        achievements: ['professional_communicator', 'team_player'],
        lastAccessDate: '2025-07-17'
      },
      '3': {
        enrolledAt: '2025-07-28',
        startedAt: null,
        completedAt: null,
        progress: 0,
        completedLessons: [],
        currentLesson: null,
        totalTimeSpent: 0,
        achievements: [],
        lastAccessDate: null
      }
    }
  },
  '5': { // Sipho Ngwenya
    enrolledModules: ['1'],
    completedModules: [],
    currentModule: '1',
    moduleProgress: {
      '1': {
        enrolledAt: '2025-07-15',
        startedAt: '2025-07-15',
        completedAt: null,
        progress: 40,
        completedLessons: ['1-1', '1-2'],
        currentLesson: '1-3',
        totalTimeSpent: 300,
        achievements: ['first_lesson'],
        lastAccessDate: '2025-07-17'
      }
    }
  },
  '6': { // Fatima Hassan
    enrolledModules: ['1', '2'],
    completedModules: ['1'],
    currentModule: '2',
    moduleProgress: {
      '1': {
        enrolledAt: '2025-07-16',
        startedAt: '2025-07-16',
        completedAt: '2025-07-17',
        progress: 100,
        completedLessons: ['1-1', '1-2', '1-3', '1-4', '1-5'],
        currentLesson: null,
        totalTimeSpent: 920,
        achievements: ['first_lesson', 'digital_literacy_expert', 'communication_pro', 'module_complete', 'speed_learner'],
        lastAccessDate: '2025-07-17'
      },
      '2': {
        enrolledAt: '2025-07-21',
        startedAt: '2025-07-21',
        completedAt: null,
        progress: 20,
        completedLessons: ['2-1'],
        currentLesson: '2-2',
        totalTimeSpent: 180,
        achievements: ['professional_communicator'],
        lastAccessDate: '2025-07-17'
      }
    }
  },
  '7': { // John Smith
    enrolledModules: ['1', '2', '3'],
    completedModules: ['1', '2'],
    currentModule: '3',
    moduleProgress: {
      '1': {
        enrolledAt: '2025-07-12',
        startedAt: '2025-07-12',
        completedAt: '2025-07-16',
        progress: 100,
        completedLessons: ['1-1', '1-2', '1-3', '1-4', '1-5'],
        currentLesson: null,
        totalTimeSpent: 1100,
        achievements: ['first_lesson', 'digital_literacy_expert', 'communication_pro', 'module_complete'],
        lastAccessDate: '2025-07-16'
      },
      '2': {
        enrolledAt: '2025-07-21',
        startedAt: '2025-07-21',
        completedAt: '2025-07-25',
        progress: 100,
        completedLessons: ['2-1', '2-2', '2-3', '2-4', '2-5'],
        currentLesson: null,
        totalTimeSpent: 960,
        achievements: ['professional_communicator', 'team_player', 'leadership_star', 'module_complete'],
        lastAccessDate: '2025-07-25'
      },
      '3': {
        enrolledAt: '2025-07-28',
        startedAt: '2025-07-28',
        completedAt: null,
        progress: 35,
        completedLessons: ['3-1'],
        currentLesson: '3-2',
        totalTimeSpent: 240,
        achievements: ['industry_ready'],
        lastAccessDate: '2025-07-17'
      }
    }
  },
  '8': { // Zanele Khumalo
    enrolledModules: ['1'],
    completedModules: [],
    currentModule: '1',
    moduleProgress: {
      '1': {
        enrolledAt: '2025-07-13',
        startedAt: '2025-07-13',
        completedAt: null,
        progress: 100,
        completedLessons: ['1-1', '1-2', '1-3', '1-4', '1-5'],
        currentLesson: null,
        totalTimeSpent: 1000,
        achievements: ['first_lesson', 'digital_literacy_expert', 'communication_pro', 'module_complete', 'streak_7'],
        lastAccessDate: '2025-07-17'
      }
    }
  }
};

export const achievements = [
  { id: 'first_lesson', name: 'First Step', description: 'Complete your first lesson', icon: '🎯' },
  { id: 'digital_literacy_expert', name: 'Digital Literacy Expert', description: 'Master digital fundamentals', icon: '💻' },
  { id: 'communication_pro', name: 'Communication Pro', description: 'Excel in digital communication', icon: '📱' },
  { id: 'professional_communicator', name: 'Professional Communicator', description: 'Master workplace communication', icon: '🗣️' },
  { id: 'module_complete', name: 'Module Complete', description: 'Complete an entire module', icon: '🏆' },
  { id: 'team_player', name: 'Team Player', description: 'Excel in teamwork and collaboration', icon: '🤝' },
  { id: 'leadership_star', name: 'Leadership Star', description: 'Demonstrate leadership qualities', icon: '⭐' },
  { id: 'industry_ready', name: 'Industry Ready', description: 'Prepared for industry-specific work', icon: '🏭' },
  { id: 'streak_7', name: '7 Day Streak', description: 'Study for 7 consecutive days', icon: '🔥' },
  { id: 'speed_learner', name: 'Speed Learner', description: 'Complete lessons ahead of schedule', icon: '⚡' },
  { id: 'project_complete', name: 'Project Complete', description: 'Complete a project assignment', icon: '🚀' },
  { id: 'certification_ready', name: 'Certification Ready', description: 'Prepared for professional certification', icon: '📜' }
];